const PO_SUFFIX_RANGE = 10000;

const PO_SUFFIX_LENGTH = 4;

export const generatePoNumber = (date: Date = new Date()): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const suffix = String(Math.floor(Math.random() * PO_SUFFIX_RANGE)).padStart(
        PO_SUFFIX_LENGTH,
        '0'
    );

    return `MT-${year}-${month}${day}-${suffix}`;
};
